<template>
    <div class="container is-fluid">
        <section class="section alphabet-section">
            <h1 class="title">The sign language alphabet</h1>
            <h2 class="subtitle">
                Start typing a message to get the symbol translation for each letter.
            </h2>
            <b-field class="input-box" position="is-centered">
                <b-input size='is-medium'
                         possition="is-center"
                         v-model = 'sentence'
                         placeholder="Type your sentence."
                         @input="transformText"/>
            </b-field>

            <div id="whole-message" class="whole-message-padding">
                <div class="" v-for="(item, index) in newSentence" :key="index">
                    <div class='space' v-if="item === ' '"/>
                    <div class='symbol' v-if="isSymbol(item) && item !== ' '">{{item}}</div>
                    <div v-if="!isSymbol(item)">
                        <img class="display-image"
                                 :src="require(`@/assets/deaf-alphabet/svg/${item}`)"
                                 alt='index'/>
                    </div>
                </div>
            </div>

            <div class="download-button" v-if="this.newSentence.length !== 0">
                <a href="#" id="btn-download"
                   class="button is-info"
                   @click="downloadMessage">Download message</a>
            </div>
        </section>
        <section class="section text-section">
            <div>
                <span>Share this with your loved ones! </span>
            </div>
            <div>
                <span><i>"Kindness is the language which the deaf can hear and the blind can see."</i></span>
            </div>
            <div>
                <span><i>Mark Twain</i></span>
            </div>
        </section>
    </div>
</template>

<script>
  import html2canvas from "html2canvas";
  import saveAs  from 'file-saver';

  let symbols = new Set([' ', ',', '.', '?', '!', '\'']);

  function createMapWithDeafAlphabet() {
    const deafAlphabetMap = new Map();
        for (let index = 65; index <= 90; index++) {
            deafAlphabetMap.set(
              String.fromCharCode(index),
                  `letter-${String.fromCharCode(index).toLowerCase()}.svg`,
            );

            deafAlphabetMap.set(' ', ' ');
            deafAlphabetMap.set(',', ',');
            deafAlphabetMap.set('.', '.');
            deafAlphabetMap.set('?', '?');
            deafAlphabetMap.set('!', '!');
            deafAlphabetMap.set('\'', '\'');
      }
    return deafAlphabetMap;
  }

export default {
  mounted() {
    this.sentence = 'Hello world!';
    this.transformText();
  },
  name: 'Home',
  components: {
  },
  data() {
    return {
      sentence: '',
      newSentence: [],
    };
  },
  methods: {
    isSymbol(item) {
      return symbols.has(item);
    },
    transformText () {
      if (this.newSentence.length !== 0){
        this.newSentence = [];
      }
      const deafAlphabetMap = createMapWithDeafAlphabet();
      this.newSentence = this.generateNewSentence(deafAlphabetMap, this.sentence);
    },

    // eslint-disable-next-line no-unused-vars
    generateNewSentence(map, sentence) {
      let newSentence = [];
        for (let index = 0; index < sentence.length; index++) {
          const letter = sentence[index].toUpperCase();
          newSentence[index] = map.get(letter);
        }
        return newSentence;
    },

    async downloadMessage () {
      this.$ga.event('Button', 'click', 'Download message', 21);
      html2canvas(document.getElementById("whole-message"))
        .then(canvas => {
          const timestamp = Date.now();
          canvas.toBlob(function(blob) {
            saveAs(blob, timestamp + ".jpeg");
          });

          // eslint-disable-next-line no-unused-vars
      }).catch((error) => {
        console.log('error');
        console.log(error);
      });
    }
  }
}
</script>

<style scoped>
.display-image {
    height: 55px;
}
.space {
    height: 50px;
    width: 40px;
}
.symbol {
    font-size: 55px;
    line-height: 1;
}
.download-button {
    margin-top: 50px;
}
.whole-message-padding {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    margin-top: 50px;
}
.input-box {
    margin-top: 50px;
}

.alphabet-section {
    padding-top: 5px;
}

.text-section {
    padding-top: 80px !important;
    padding-bottom: 0px !important;
}

</style>